// Snippet / Decision Card presentation config (no logic — display only).

export const ACTION_LABEL = {
    approve: "Approve", reject: "Reject", simulate: "Simulate", accept: "Accept",
    ignore: "Ignore", assign: "Assign", escalate: "Escalate", review: "Review",
    compare: "Compare", edit: "Edit", execute: "Execute", pause: "Pause",
    view_details: "View Details", download: "Download", open_source_data: "Open Source",
};

// Actions that visually read as "primary / positive"
export const PRIMARY_ACTIONS = new Set(["approve", "accept", "execute", "assign"]);
export const DANGER_ACTIONS = new Set(["reject", "ignore", "pause"]);

export const STATE_STYLE = {
    draft: "text-neutral-600 bg-neutral-100",
    generated: "text-violet-700 bg-violet-50",
    viewed: "text-sky-700 bg-sky-50",
    pending_action: "text-amber-700 bg-amber-50",
    approved: "text-emerald-700 bg-emerald-50",
    rejected: "text-rose-700 bg-rose-50",
    executed: "text-emerald-700 bg-emerald-50",
    archived: "text-neutral-500 bg-neutral-100",
    expired: "text-neutral-400 bg-neutral-100",
};

export const PRIORITY_STYLE = {
    low: "text-neutral-600 bg-neutral-100",
    medium: "text-sky-700 bg-sky-50",
    high: "text-amber-700 bg-amber-50",
    critical: "text-rose-700 bg-rose-50",
    urgent: "text-rose-700 bg-rose-50",
};

export function prettyState(s) {
    return String(s || "").replace(/_/g, " ");
}

// Card type -> small glyph key (reuses wsui ActionIcon set)
export const CARD_ICON = {
    approval: "check", budget_recommendation: "wallet", hiring_decision: "user",
    vendor_payment: "wallet", purchase_request: "cart", invoice_review: "receipt",
    cash_flow: "trending", revenue_forecast: "trending", profit_forecast: "trending",
    sales_opportunity: "target", customer_alert: "alert", risk_alert: "alert",
    compliance_alert: "shield", inventory_alert: "box", contract_renewal: "file",
    meeting_summary: "calendar", employee_performance: "star", marketing_campaign: "megaphone",
    task_assignment: "check", kpi_summary: "chart", business_insight: "search",
    simulation: "refresh", ai_recommendation: "flag", action_plan: "flag",
};
